import {
  CustomerStatus,
  CustomerStatusEnum,
} from '../shared/models/customer-status.enum';
import { LookupService } from '../../shared/services/lookup.service';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { CustomerModel } from '../shared/models/customer-model';
import { CommonLookupItem } from '../../shared/models/common-lookup-item.model';
import { CustomerFilterModel } from '../shared/models/customer-filter-model';
import { PagingFilter } from '../../shared/models/paging-filter.model';
import { PagingWrapper } from '../../core/models/paging-wrapper';
import { CustomerService } from '../shared/services/customer.service';
import { Component, DestroyRef, OnInit } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { CustomMessageService } from '@admin/core/message.service';
import { MessageType } from '@admin/core/models/enum/message-type';
import { ApplicationMessage } from '@admin/core/models/application-message';
import { ApplicationMessageSource } from '@admin/core/models/application-message-source';
import { UserService } from '@admin/core/user.service';
import { FeatureEnum } from '@admin/shared/models/feature-enum';
import { Table } from 'primeng/table';
import { SelectCustomerStatuses } from '../shared/models/customer-status.model';
import { PortfolioModel } from '@admin/portfolios/shared/models/portfolio-model';
import { PortfolioService } from '@admin/portfolios/shared/services/portfolio.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EnvService } from '@hrra/core';
import { ApiTypes } from '@admin/core/api-types';
import { AuthService } from '@admin/core/auth.service';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.less'],
  standalone: false,
})
export class CustomerListComponent implements OnInit {
  public filterPagingWrapper: CustomerFilterModel;

  public localities: CommonLookupItem<number, string>[];
  public customerStatuses: CommonLookupItem<number, string>[];

  public totalModeration: number;

  public isForBorder = true;

  public switchFilterStatuses: SelectCustomerStatuses[];

  public switchFilterStatus: number;

  public portfolios: PortfolioModel[];

  public CustomerStatusEnum: any;

  public customerList: CustomerModel[];

  public totalRecords: number;

  public lastLoadEvent: LazyLoadEvent;

  public dateFormat: string;
  public specialDateFormat: string;
  public pageSize: number;

  private isReset: boolean;

  public currentDate: Date;

  //public apiBaseUrl: string;

  public hasCustomerDeletePermission: boolean;

  onLoad(event: LazyLoadEvent) {
    if (this.isReset) {
      this.customerList = [];
      this.totalRecords = 0;
      return;
    }

    if (event.sortField && event.sortOrder) {
      this.filterPagingWrapper.sortParameters = [
        {
          column: event.sortField,
          order: event.sortOrder == 1 ? 'asc' : 'desc',
        },
      ];
    }

    this.filterPagingWrapper.start = event.first;
    this.filterPagingWrapper.limit = event.rows;
    this.lastLoadEvent = event;
    this.onFilter();
  }

  onFilter() {
    this.filterPagingWrapper.start = this.filterPagingWrapper.start || 0;
    this.filterPagingWrapper.statusId = this.switchFilterStatus;

    this.customerService
      .listCustomer(this.filterPagingWrapper)
      .subscribe((d) => {
        this.totalRecords = d.data.totalCount;
        this.customerList = d.data.items;
      });

    this.customerService.getModerationCount().subscribe((d: any) => {
      this.totalModeration = d.data.totalModerationCount;
    });
  }

  onApplyClick(dt: Table, value?: CustomerStatus) {
    if (value) {
      this.switchFilterStatus = value;
    }

    this.filterPagingWrapper.start = 0;

    //TODO: bug in paginator, does not update state correctly, change this code after bug is fixed in framework (primeng)
    this.isReset = true;
    dt.reset();
    this.isReset = false;

    this.onFilter();
  }

  onClearClick() {
    this.filterPagingWrapper = {};
  }

  onLoginAsCustomer(customerId: number){
    this.authService.loginAsCustomer(customerId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      //display message
    });
  }

  getSpecialDateFormat(format: string) {
    return format.replace('MM', 'mm').replace('yyyy', 'yy');
  }

  onCustomerDelete(customer: CustomerModel) {
    if (confirm(this.translateService.instant('message.AreYouSure'))) {
      this.customerService
        .deleteCustomer(customer.customerId)
        .subscribe((r) => {
          if (r.success) {
            this.showMessage(r.message, MessageType.Success);
          } else {
            this.showMessage(r.message, MessageType.Error);
          }
        });
    }
  }

  constructor(
    private lookupService: LookupService,
    private config: ConfigurationService,
    private customerService: CustomerService,
    private translateService: TranslateService,
    private translate: TranslateService,
    private messageService: CustomMessageService,
    private userService: UserService,
    private portfolioService: PortfolioService,
    private authService: AuthService,
    private destroyRef: DestroyRef
  ) {
    this.filterPagingWrapper = { registrationDate: { from: null, to: null } };
    this.localities = [];
    this.customerStatuses = [];
    this.CustomerStatusEnum = CustomerStatusEnum;
    this.hasCustomerDeletePermission = false;
    this.switchFilterStatus = CustomerStatus.All;
  }

  ngOnInit() {

    let lookupData = this.lookupService.getCachedLookupData();
    this.localities = lookupData.localities;
    this.customerStatuses = lookupData.customerProfileStatuses.filter(
      (s) => s.value != CustomerStatusEnum.Deleted
    );
    this.hasCustomerDeletePermission =
      this.userService.currentUser.features.some(
        (f) => f == FeatureEnum.DeleteCustomer
      );

    let config = this.config.getCachedConfig();

    this.dateFormat = config.dateFormat;
    this.specialDateFormat = this.getSpecialDateFormat(this.dateFormat);
    this.pageSize = config.defaultPageSize;
    this.currentDate = new Date();
    this.portfolioService.getPortfolios().subscribe((p) => {
      this.portfolios = p.items;
    });
    // this.customerService.getModerationCount().subscribe((d:any) => {
    //   this.totalModeration = d.data.totalModerationCount
    // })

    this.switchFilterStatuses = [
      {
        label: this.translate.instant('label.All'),
        value: CustomerStatus.All,
        styleClass: 'all-button',
        isInModeration: false,
      },
      {
        label: this.translate.instant('label.InModeration'),
        value: CustomerStatus.Pending,
        styleClass: 'moderation-button',
        isInModeration: true,
      },
      {
        label: this.translate.instant('label.Active'),
        value: CustomerStatus.Active,
        styleClass: 'active-button',
        isInModeration: false,
      },
      {
        label: this.translate.instant('label.Archived'),
        value: CustomerStatus.Archived,
        styleClass: 'archived-button',
        isInModeration: false,
      },
      {
        label: this.translate.instant('label.Rejected'),
        value: CustomerStatus.Rejected,
        styleClass: 'rejected-button',
        isInModeration: false,
      },
    ];
  }

  public getLabel(inModeration: boolean, label: string) {
    if (inModeration) {
      if (this.totalModeration != null) {
        return `${label}(${this.totalModeration})`;
      } else {
        return `${label}(0)`;
      }
    } else {
      return `${label}`;
    }
  }

  public getColorByStatus(statusId: number, isForBorder: boolean) {
    if (statusId === CustomerStatus.Active) {
      return CustomerStatusColorEnum.Active;
    } else if (statusId === CustomerStatus.Pending) {
      return CustomerStatusColorEnum.Pending;
    } else if (statusId === CustomerStatus.Rejected) {
      return CustomerStatusColorEnum.Rejected;
    } else if (statusId === CustomerStatus.Archived) {
      return CustomerStatusColorEnum.Archived;
    } else if (isForBorder && CustomerStatus.Deleted) {
      return CustomerStatusColorEnum.Deleted;
    }
  }

  private showMessage(message: string, type: MessageType) {
    if (message != null && message.length > 0) {
      this.messageService.pushMessage(<ApplicationMessage>{
        type: type,
        sourceId: ApplicationMessageSource.global,
        summary: '',
        detail: message,
      });
    }
  }
}
export enum CustomerStatusColorEnum {
  Active = '#85C226',
  Rejected = '#E4480E',
  Pending = '#F66',
  Archived = '#F7CD3A',
  Deleted = '#e2e8f0',
}
